import './vendor/slick/slick.min'
import './vendor/magnific-popup/magnific-popup.min'

    ;
(function ($) {

    // Scripts which runs after DOM load

    $(document).ready(function () {


        let trigger = document.querySelector('#toggle-menu');
        let box = document.querySelector('#nav-menu');
        trigger.addEventListener('click', function () {
            box.classList.toggle('open');
            trigger.classList.toggle("active");
            box.style.display = 'block';
        });

        $('.mbp-popup_btn').click(function(){
            if($(this).hasClass('mbp-popup_btn--open')){
                if($(this).parent().hasClass('left-title-right-content_content')) {
                    $(this).parent().find('.left-title-right-content_content-wrapper').removeClass('left-title-right-content_content-wrapper--open');
                }
                if($(this).parent().hasClass('text-quote__content')) {
                    $(this).parent().find('.text-quote__wrapper').removeClass('text-quote_content-wrapper--open');
                }
            } else {
                if($(this).parent().hasClass('left-title-right-content_content')) {
                    $(this).closest('.left-title-right-content_content').find('.left-title-right-content_content-wrapper').addClass('left-title-right-content_content-wrapper--open');
                }
                if($(this).parent().hasClass('text-quote__content')) {
                    $(this).closest('.text-quote__content').find('.text-quote__wrapper').addClass('text-quote_content-wrapper--open');
                }
            }
            $(this).toggleClass('mbp-popup_btn--open')
        });

        // show btn if heigh more than wrapper
        function showMbpBtn() {
            $('.left-title-right-content_content-wrapper').each(function(){
                let height = $(this).height();
                if(height >= 211) {
                    $(this).closest('.left-title-right-content_content').find('.mbp-popup_btn').show();
                } else {
                    $(this).closest('.left-title-right-content_content').find('.mbp-popup_btn').hide();
                }
            });
            $('.text-quote__wrapper').each(function(){
                let height = $(this).height();
                if(height >= 121) {
                    $(this).closest('.text-quote__content').find('.mbp-popup_btn').show();
                } else {
                    $(this).closest('.text-quote__content').find('.mbp-popup_btn').hide();
                }
            });
        };
        showMbpBtn();


        $('.video_section_button').parent().click(function () {
            if($(this).children(".video_section_button").get(0).paused){
                $(this).children(".video_section_button").get(0).play();
                $(this).children(".playpause").fadeOut();
            }else{
                $(this).children(".video_section_button").get(0).pause();
                $(this).children(".playpause").fadeIn();
            }
        });
        $(document).ready(function () {
            $('.slick_banner').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                adaptiveHeight: true,
                prevArrow: '<div class="slide_arrow_height"><button class="slide-arrow prev-arrow"></button></div>',
                nextArrow: '<div class="slide_arrow_height-left"><button class="slide-arrow next-arrow"></button></div>',
                dotsClass: 'custom_dots',
                dots: true,
            });
        });
        $('.search_box').click(function() {
            $('.search-form').show();
            $('.search-option').animate ({left : 0},100);
        });
        $('.search-form_close').click(function() {
            $('.search-form').hide();
            if(window.outerWidth < 1250){
                $('.blur_mob').css('display','none');
            }
        });
        $(document).mouseup(function(e) {
            var container = $('.search-form');

            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0)
            {
                container.hide();
                if(window.outerWidth < 1250){
                    $('.blur_mob').css('display','none')
                }
            }
        });

        $('.slider-photo-doctor__slick').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: true,
                        dotsClass: 'slider_dots',
                    }
                }
            ]

        });

        $('.video-slider').slick({
            slidesToShow: 3,
            arrows: true,
            prevArrow: '<button class="slide-arrow prev-arrow"></button>',
            nextArrow: '<button class="slide-arrow next-arrow"></button>',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        dotsClass: 'slider_dots',

                    }
                }
            ]
        });
        var popup = {
            // Initializer
            init: function() {
                popup.popupVideo();
            },
            popupVideo : function() {

                $('.popup-player').magnificPopup({
                    type: 'iframe',
                    mainClass: 'mfp-fade',
                    removalDelay: 160,
                    preloader: false,
                    fixedContentPos: false,
                    iframe: {
                        markup: '<div class="mfp-iframe-scaler">'+
                            '<div class="mfp-close"></div>'+
                            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                            '</div>',

                        srcAction: 'iframe_src',
                    }
                });

            }
        };
        popup.init($);
        $('.video_section_button').parent().click(function () {
            if($(this).children(".video_section_button").get(0).paused){
                $(this).children(".video_section_button").get(0).play();
                $(this).children(".playpause").fadeOut();
            }else{
                $(this).children(".video_section_button").get(0).pause();
                $(this).children(".playpause").fadeIn();
            }
        });

        $('.faq-box__title').click(function () {
            $(this).closest(".faq-box").find(".faq-box__content").slideToggle()
            $(this).closest(".faq-box").find(".faq-box__title .faq-btn").toggleClass('faq-btn--open')
        })
        $('.header-box__menu li').has('ul').children('a').after( "<div class='navlist-arrow '></div>" );

        $('.navlist-arrow').click(function () {
            $(this).toggleClass('rotate-arrow');
            $(this).closest("li").find("ul.sub-menu").first().slideToggle();
        });


        $('.gallery-item').slick({
            slidesToShow: 1,
            arrows: true,
            prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });



        $(document).on("click", ".wpgmaps_blist_row", function () {

            // Fetch the lat/lng value from the data attribute
            const latLng = $(this).data("latlng");

            if (latLng) {

                // Split the lat/lng and parse them as float values
                const [lat, lng] = latLng.split(", ").map(coord => parseFloat(coord));

                // Google Maps Geocoding API request
                const geocoder = new google.maps.Geocoder();

                geocoder.geocode({ location: { lat, lng } }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK && results.length) {
                        // Loop through the address components to find the state
                        let stateAbbreviation = '';
                        for (let i = 0; i < results[0].address_components.length; i++) {
                            const component = results[0].address_components[i];
                            if (component.types.includes('administrative_area_level_1')) {
                                stateAbbreviation = component.short_name;
                                break;
                            }
                        }

                        // Ensure stateAbbreviation was found
                        if (stateAbbreviation) {

                            // Mapping of state abbreviations to full state names
                            const stateNames = {
                                AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California",
                                CO: "Colorado", CT: "Connecticut", DE: "Delaware", FL: "Florida", GA: "Georgia",
                                HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana", IA: "Iowa", KS: "Kansas",
                                KY: "Kentucky", LA: "Louisiana", ME: "Maine", MD: "Maryland", MA: "Massachusetts",
                                MI: "Michigan", MN: "Minnesota", MS: "Mississippi", MO: "Missouri", MT: "Montana",
                                NE: "Nebraska", NV: "Nevada", NH: "New Hampshire", NJ: "New Jersey", NM: "New Mexico",
                                NY: "New York", NC: "North Carolina", ND: "North Dakota", OH: "Ohio", OK: "Oklahoma",
                                OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina", SD: "South Dakota",
                                TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont", VA: "Virginia", WA: "Washington",
                                WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming"
                            };

                            const state = stateNames[stateAbbreviation] || stateAbbreviation;

                            // Create the new div with the state name
                            const newDiv = `<div class="new-state-display"><h2>${state}</h2></div>`;

                            // Check if the div already exists and replace it, otherwise insert it
                            const existingDiv = $(".new-state-display");

                            if (existingDiv.length) {
                                existingDiv.replaceWith(newDiv);
                            } else {
                                $("#wpgmza_marker_list_1").find(".wpgmaps_blist_row").first().before(newDiv);
                            }
                        } else {
                            console.warn("State abbreviation not found from the geocode result.");
                        }
                    } else {
                        console.warn("Geocoding failed or no results found.");
                    }
                });
            } else {
                console.warn("LatLng data attribute is missing or invalid.");
            }
        });

    });

    document.addEventListener('DOMContentLoaded', function () {
        const isMobileOrTablet = window.matchMedia('(max-width: 1119px)').matches;
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: isMobileOrTablet ? 0.1 : 0.2
        };

        const observerCallback = (entries, observer) => {
            entries.forEach(entry => {
                setTimeout(() => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate__animated');
                        entry.target.style.opacity = 1;
                        observer.unobserve(entry.target);
                    }
                }, 200);
            });
        };

        const observer = new IntersectionObserver(observerCallback, options);

        // Get all elements with the class `.animate__fadeIn`
        const elements = Array.from(document.querySelectorAll('.animate__fadeIn'));

        // Set opacity to 1 for the first `.animate__fadeIn` element
        if (elements.length > 0) {
            elements[0].style.opacity = 1;
        }

        // Set opacity to 1 for elements with `.content_video_slide` and remove them from observer
        document.querySelectorAll('.content_video_slide').forEach(element => {
            element.style.opacity = 1;
        });

        // Skip the first `.animate__fadeIn` element and observe the rest
        elements.slice(1).forEach(element => {
            if (!element.classList.contains('content_video_slide')) {
                element.style.opacity = 0;
                observer.observe(element);
            }
        });
    });

    // accordion for doctors
    document.addEventListener('DOMContentLoaded', function() {
        const accordions = document.querySelectorAll('.doctor-accordion-item');
        accordions.forEach(item => {
            const header = item.querySelector('.doctor-accordion-header');
            const content = item.querySelector('.doctor-accordion-content');
            const arrow = header.querySelector('.accordion-arrow');

            header.addEventListener('click', () => {
                const isActive = content.classList.contains('active');

                // Close all accordions and reset arrow rotation
                document.querySelectorAll('.doctor-accordion-content').forEach(c => c.classList.remove('active'));
                document.querySelectorAll('.accordion-arrow').forEach(a => a.classList.remove('rotated'));

                // If the current accordion was closed, open it and rotate the arrow
                if (!isActive) {
                    content.classList.add('active');
                    arrow.classList.add('rotated');
                }
            });

        });
    });

    document.addEventListener('DOMContentLoaded', function () {
        const banner = document.querySelector('[data-banner]');
        const closeBtn = document.querySelector('.js-close-banner');
    
        if (closeBtn) {
            closeBtn.addEventListener('click', function (e) {
                e.preventDefault();
                if (banner) {
                    banner.style.display = 'none';
                }
    
                // Set cookie for 1 year
                document.cookie = "header_banner_closed=true; path=/; max-age=" + (60 * 60 * 24 * 365);
                
            });
        }
    });

    // search doctors
    document.addEventListener('DOMContentLoaded', function() {
        const searchInput = document.getElementById('doctor-search');
        const doctorItems = document.querySelectorAll('.doctor-item');
        if (searchInput){
            searchInput.addEventListener('input', function() {
                const searchQuery = this.value.toLowerCase().trim();

                if (searchQuery.length >= 2) {
                    doctorItems.forEach(item => {
                        const doctorName = item.querySelector('.doctor-list__title h3').textContent.toLowerCase();

                        // Check if the full name includes the search query
                        const matches = doctorName.includes(searchQuery);

                        if (matches) {
                            item.style.display = 'block';
                            item.closest('.doctor-accordion-item').querySelector('.doctor-accordion-content').classList.add('active');
                        } else {
                            item.style.display = 'none';
                        }
                    });
                } else {
                    doctorItems.forEach(item => {
                        item.style.display = 'block';
                        item.closest('.doctor-accordion-item').querySelector('.doctor-accordion-content').classList.remove('active');
                    });
                }
            });
        }
    });



    // Scripts which runs after all elements load

    $(window).on('load', function () {


    });

    // Scripts which runs at window resize

    $(window).resize(function () {

        //jQuery code goes here

    });

}(jQuery));


